/* eslint-disable react/prop-types */
import React, { useState } from 'react';

import SaveIcon from '@mui/icons-material/Save';
import { Typography, Box, TextField } from '@mui/material';

import { CustomSaveButton } from './styles';

export function OrderNotes({ orderDetails, saveNotes }) {
  const [editedNotes, setEditedNotes] = useState(orderDetails.note || '');

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Typography variant="h6" sx={{ padding: '0 0 20px 0' }}>
          <Box sx={{ fontWeight: 'bold' }}> Notas</Box>
        </Typography>
        <CustomSaveButton
          onClick={async () => {
            await saveNotes(editedNotes);
          }}
        >
          <SaveIcon
            color={
              editedNotes !== orderDetails.note
                ? 'var(--color-blue-primary)'
                : 'disabled'
            }
          />
        </CustomSaveButton>
      </Box>
      <TextField
        sx={{ width: '100%' }}
        placeholder="Suas notas aqui"
        multiline
        rows={6}
        value={editedNotes}
        onChange={(e) => {
          setEditedNotes(e.target.value);
        }}
      />
    </>
  );
}
